import React, { useState } from 'react';
import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import Story from '../stories/Story';
import Loader from '../../components/Loader';
import EmptyState, { EmptyStateActions } from '../../components/EmptyState';
import { useConnect, UseQueryConnect } from '@lore/query-connect';
import SectionHeader from '../../components_profiles/SectionHeader';
import { LinkButton, OutlineButton } from '../../components/Button';
import { LightBulbIcon } from '@heroicons/react/24/outline';

export default function Stories(props) {
  const [timestamp] = useState(new Date().toISOString());

  const currentUser = useUser();

  const storyBookmarks = useConnect('bookmark.find', {
    where: {
      eager: {
        $where: {
          creatorId: currentUser.id,
          storyId: {
            $null: false
          },
          // createdAt: {
          //   $lt: timestamp
          // }
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });

  if (storyBookmarks.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (storyBookmarks.data.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <SectionHeader
        title="Impact Stories"
        subtitle={`${storyBookmarks.data.length} impact stor${storyBookmarks.data.length === 1 ? 'y' : 'ies'} bookmarked`}
      />
      {storyBookmarks.data.length === 0 ? (
        <EmptyState
          icon={LightBulbIcon}
          title="Looks like you don't have any impact stories bookmarked yet."
          subtitle="After bookmarking impact stories, you will see them here."
        >
          <EmptyStateActions>
            <LinkButton
              button={OutlineButton}
              to="/stories"
              label="Explore impact stories"
            />
          </EmptyStateActions>
        </EmptyState>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {storyBookmarks.data.map(function(storyBookmark, index) {
            return (
              <UseQueryConnect key={index} _key="story.byId" params={{ id: storyBookmark.data.storyId }}>
                {function(story) {
                  if (story.state === PayloadStates.FETCHING) {
                    return (
                      <Loader key={index}/>
                    );
                  }

                  return (
                    <Story
                      key={index}
                      story={story}
                    />
                  );
                }}
              </UseQueryConnect>
            );
          })}
        </div>
      )}
    </div>
  );
};
